import { render, staticRenderFns } from "./deliveryorder.vue?vue&type=template&id=277534dd&scoped=true"
import script from "./deliveryorder.vue?vue&type=script&lang=js"
export * from "./deliveryorder.vue?vue&type=script&lang=js"
import style0 from "./deliveryorder.vue?vue&type=style&index=0&id=277534dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277534dd",
  null
  
)

export default component.exports